import React from "react";
import VehiculoCard from "./VehiculoCard";
import FiltroVehiculos from "./FiltroVehiculos";

const ModelosDropdown = ({
  activeFilter,
  onFilterClick,
  autos,
  camionetasSuv,
  pickups,
  utilitarios,
  todosLosVehiculos,
  onLinkClick,
  maxHeight,
}) => {
  /*   const handleLinkClick = (e) => {
    // Lógica para manejar clics en los enlaces
    if (e.target.closest('.filtro-link')) {
      return; // No cerrar si es un enlace de filtro
    }
    onFilterClick(activeFilter); // Llamar a la función de clic
  }; */

  return (
    <div
      className="absolute left-0 right-0 bg-white text-midnight-black shadow-lg z-40 w-full overflow-y-auto"
      style={{ maxHeight: maxHeight ? `${maxHeight}px` : "calc(100vh - 116px)" }}>
      {/* Sección de filtros con fondo que abarca toda la pantalla */}
      <div className="sticky top-0 z-10">
        <FiltroVehiculos
          activeFilter={activeFilter}
          onFilterClick={onFilterClick}
        />
      </div>
      {/* Contenido de modelos */}
      <div className="px-5 md:px-10 lg:px-20 py-6">
        {/* Modelos de vehículos */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {/* Vista "Todos": orden combinado explícito (ver todosLosVehiculos) */}
          {activeFilter === "todos" &&
            todosLosVehiculos.map((vehiculo, index) => (
              <VehiculoCard
                key={`todos-${index}`}
                vehiculo={vehiculo}
                onClick={(e) => {
                  onLinkClick(e); // Llamar a la función para cerrar el dropdown
                }}
              />
            ))}

          {activeFilter === "suv" &&
            camionetasSuv.map((suv, index) => (
              <VehiculoCard
                key={`suv-${index}`}
                vehiculo={suv}
                onClick={(e) => {
                  onLinkClick(e); // Llamar a la función para cerrar el dropdown
                }}
              />
            ))}

          {activeFilter === "pickups" &&
            pickups.map((pickup, index) => (
              <VehiculoCard
                key={`pickup-${index}`}
                vehiculo={pickup}
                onClick={(e) => {
                  onLinkClick(e); // Llamar a la función para cerrar el dropdown
                }}
              />
            ))}

          {activeFilter === "autos" &&
            autos.map((auto, index) => (
              <VehiculoCard
                key={`auto-${index}`}
                vehiculo={auto}
                onClick={(e) => {
                  onLinkClick(e); // Llamar a la función para cerrar el dropdown
                }}
              />
            ))}

          {activeFilter === "utilitarios" &&
            utilitarios.map((util, index) => (
              <VehiculoCard
                key={`util-${index}`}
                vehiculo={util}
                onClick={(e) => {
                  onLinkClick(e); // Llamar a la función para cerrar el dropdown
                }}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default ModelosDropdown;
